import React from 'react';
import "./TermsOfService.css";

const TermsOfService = () => {
  return (
    <div className="terms-of-service">
      <h1>Általános Szerződési Feltételek (ÁSZF)</h1>

      <p>
      Császár Travel Utazásszervező Kft. (továbbiakban: Utazásszervező) Székhelye: 8868,
Murarátka Hunyadi János utca 1.; Telephelye: 8960, Lenti, Kossuth Lajos út 1.;
Cégjegyzékszám: 20-09-079589; Adószáma: 32765179-2-20.;
Nyilvántartási száma: U-002083; Tel.: +36 30 182 72 02; E-mail: info@csaszartravel.hu;
Web: www.csaszartravel.hu
      </p>

      <p>
      A Császár Travel számára előírt utazásszervezői vagyoni biztosíték biztosítását és a
fizetésképtelenséggel szembeni védelem biztosítását az Európai Utazási Biztosító Zrt.-vel
kötötte. A vagyoni biztosíték hatálya: kiutaztatás, valamint belföldi utaztatás. Az Európai
Utazási Biztosító Zrt. az Utazásszervezők Vagyoni Biztosíték Biztosítása szabályzatban
foglalt rendelkezések szerint átvállalja az Utazásszervező és Utazásközvetítő kártérítési
kötelezettségéből adódó károk megtérítését. A Biztosító elérhetősége: Európai Utazási
Biztosító Zrt. 1132 Budapest, Váci út 36-38.; telefon: +36-1-452-3580; web: www.eub.hu.
      </p>

      <p>
      A Császár Travel által szervezett külföldi utazásokra a Polgári Törvénykönyvről szóló 2013.
évi V. törvény 6:254. §-ának rendelkezései, továbbá az utazási szolgáltatásokra vonatkozó
szerződésekről, különösen az utazási csomagra és az utazási szolgáltatásegyüttesre
vonatkozó szerződésekről szóló 472/2017. (XII.28.) Korm. rendelet 34/A. § (4)
bekezdésében foglaltak, valamint a 2009. évi LXXVI. törvény és a 210/2009. (IX.29.)
Kormányrendelet a szolgáltatási tevékenység megkezdésének és folytatásának általános
szabályairól szóló rendelkezései, illetve az általános szerződési feltételekben foglaltak az
irányadóak.
      </p>

      <h2>A SZERZŐDÉSKÖTÉS ÉS A DÍJFIZETÉS FELTÉTELEI</h2>
      <p>
      1. Az Utas az utazási szerződés aláírásával egyidejűleg részvételi díjelőleget fizet. A
megfizetett előleg garantálja, hogy az ily módon lefoglalt helyeket az Utazásszervező más
utasnak nem értékesíti. Az Utazásszervező által közölt előleget (30 %) a jelentkezéskor, a
részvételi díj fennmaradó összegét pedig legkésőbb az utazás megkezdése előtt 30 nappal
kell megfizetni, kivéve, ha valamelyik külföldi közreműködővel kötött szerződés alapján
korábbi befizetési határidő indokolt. Felek kifejezetten megállapodnak, hogy a határidő be
nem tartását az Utas részéről az utazási szerződéstől történő elállásnak tekintik, amely a
szerződést felbontja, és az Utas ez esetben köteles az Utazásszervezőnek a szerződés IV/1.
pontjában meghatározott bánatpénzt az ott szabályozott módon és mértékben, legkésőbb az
elutazás időpontja előtt 8 nappal megfizetni, illetve Utazásszervező jogosult azt
beszámítással rendezni.
      </p>
      
      <p>
      2. A részvételi díj az utazások meghirdetett – az utazási csomagban szereplő -
szolgáltatásainak ellenértékét, az Utazásszervező eljárási díját és szervezési költségeit,
valamint az ÁFA összegét tartalmazza. A teljes részvételi díjban szereplő, és az Utast
terhelő, külön feltüntetett díjak, adók, illetékek összege az adott hatóság, illetve üzemeltető
egyoldalú rendelkezése alapján változhat. Az Utazásszervező fenntartja magának a jogot az
üresen maradt férőhelyek kedvezményes áron történő értékesítésére. A részvételi díj ily
módon történő csökkentése a már megkötött szerződésekre nem vonatkozik.
      </p>

      <p>
      3. Ha a jelentkezés az utazás megkezdése előtti 30. napon belül történik, a részvételi díj
teljes összegét a jelentkezéssel egyidejűleg kell megfizetni. Opciós foglaláskor a részvételi
díj határidőre történő megfizetésének elmulasztása esetén a megrendelés automatikusan
törlésre kerül, így nem jön létre az utazási szerződés. Bármely kedvezményre való
jogosultságot az Utasnak a megrendelésekor kell bejelentenie és igazolnia. Az utólagos
bejelentéseket az Utazásszervező nem fogadja el.
      </p>

      <p>
      4. Az Utazásszervező által meghirdetett szobatípusok esetében az egy személyre eső
részvételi díjak az adott foglalásban szereplő szobakihasználtság esetén érvényesek. A
szobában lakók létszámának módosulásával a részvételi díj személyenkénti ára is
megváltozik, pl. amennyiben valamely utas (több utas) az utazást lemondja, és ennek
következtében az adott szobatípus kihasználtsága csökken, abban az esetben – a szoba
típusától, kapacitásától és az utat lemondó személyek számától függően – az eredeti
foglalásban szereplő személyek számára az eredeti foglalástól eltérően magasabb összegű
egy főre eső részvételi díj kerül megállapításra.
      </p>

      <p>
      4. Az Utazásszervező által meghirdetett szobatípusok esetében az egy személyre eső
részvételi díjak az adott foglalásban szereplő szobakihasználtság esetén érvényesek. A
szobában lakók létszámának módosulásával a részvételi díj személyenkénti ára is
megváltozik, pl. amennyiben valamely utas (több utas) az utazást lemondja, és ennek
következtében az adott szobatípus kihasználtsága csökken, abban az esetben – a szoba
típusától, kapacitásától és az utat lemondó személyek számától függően – az eredeti
foglalásban szereplő személyek számára az eredeti foglalástól eltérően magasabb összegű
egy főre eső részvételi díj kerül megállapításra.
      </p>

<p>
5. Az Utas az utazás során a programban nem szereplő, előre be nem fizetett
szolgáltatás(oka)t csak akkor veheti igénybe, ha a helyszínen a szolgáltatás teljes részvételi
díját kifizeti az Utazásszervező képviselőjének közlése szerinti pénznemben. Az
Utazásszervezőt e szolgáltatásokkal kapcsolatos reklamációkért felelősség nem terheli
</p>
      <p>
      6. A közlekedési költségek nemzetközi egyezményen alapuló díjszabási vagy hatósági
árának megváltozása, továbbá az egyes szolgáltatásokkal kapcsolatos adó, illeték,
üzemanyagár valamint a szolgáltatóval kötött szerződésben szereplő deviza – az
Utazásszervező közreműködőjével kötött szerződésben meghatározott mutató szerinti –
forintárfolyamának időközi változása miatt az Utazásszervező a részvételi díjat az utazás
megkezdése előtt legkésőbb 21. napig felemelheti. A díjemelés indokát és mértékét, annak
számítási módjával együtt, az Utazásszervező az Utassal írásban közli. A díjemelés mértéke
a költségek emelkedésének mértékével arányos, az Utazásszervező a részvételi díjat a
költségnövekedés forintban számított összegével emeli meg. Az Utas a fenti tényezőkben
történő változások esetén, a fentiekkel egyező módon számított díjengedményre jogosult,
amennyiben a költségek a szerződéskötést követően, de az utazási csomag megkezdése
előtt csökkennek.
      </p>

      <h2>UTAZÁSI CSOMAGRA VONATKOZÓ SZERZŐDÉS</h2>
      <p>
      1. Az utazási csomagra vonatkozó szerződés (továbbiakban: utazási szerződés) az Utazó
(továbbiakban: Utas) és az Utazásszervező között az utazási szolgáltatások
megrendelésével, a jelentkezés nyilvántartásba vételével, az utazási szerződés aláírásával,
az Utazásszervező visszaigazolásával, valamint az előleg, avagy a jelen szerződésben
meghatározott esetekben a teljes összeg befizetésével jön létre. A szerződést a felek -
valamennyi kikötésével együtt írásban, két példányban írják alá, melynek egyik példányát a
jelentkezéskor az Utazásszervező átadja. Ha az Utazásszervező a jelentkezést helyhiány,
vagy más ok miatt csak feltételesen fogadja el, az utazási szerződés csak akkor lép
hatályba, ha az Utazásszervező az Utast a jelentkezés feltétel nélküli elfogadásáról
értesítette és az utazási szerződést visszaigazolta. Az utazási szerződés részét képezi az
Általános Előzetes Tájékoztató.
      </p>
      <p>
      2. Amennyiben az Utas nem személyesen jár el, hanem javára harmadik személy foglalja le
az utat, az Utazásszervező nem köteles vizsgálni, hogy e harmadik személy jogszerűen
képviseli-e az Utast, illetve, hogy az általa megadott adatok a valóságnak megfelelnek-e. Az
utazási szerződés szerint az Utast terhelő kötelezettségek az Utas javára szerződő harmadik
személyt terhelik, ide nem értve azokat a kötelezettségeket, melyek természetüknél fogva
személyesen csak az Utast érinthetik (pl. védőoltás). Az eljáró személy köteles minden, az
utazási szerződéssel kapcsolatos – birtokába jutott – okiratot, tájékoztatót utastársainak
haladéktalanul átadni. Amennyiben az eljáró személy meghatalmazást nem csatol, az
esetleges jogosulatlan megbízás ügyviteléből fakadó károkért és költségekért az eljáró
személy teljes anyagi felelősséggel tartozik. A Felek rögzítik, hogy az Utas az utazás
megkezdése előtt az utazási szerződésből fakadó jogait és kötelezettségeit átruházhatja
olyan harmadik személyre, aki az utazási szerződésben foglalt valamennyi feltételeknek
megfelel, feltéve, ha az utazásszervezőt erről az utazási csomag megkezdése előtt legalább
7 nappal, tartós adathordozón (írásban, papíron vagy az Utazásszervező elektronikus
elérhetőségén) értesíti. A Felek rögzítik továbbá, hogy a jogok és kötelezettségek
átruházását megelőzően keletkezett kötelezettségekért és az átruházásból eredő
többletköltségek megfizetéséért a megrendelő kilépő és a harmadik belépő személy
egyetemlegesen állnak helyt.
<p>
3. Az utazási szerződés alapján az utazási iroda a szerződés szerinti utazási szolgáltatást
köteles teljesíteni, az utas pedig köteles a szerződés szerinti részvételi díjat és egyéb
költségeket megfizetni.
</p>
<p>
4. Az utazás időtartamát, az utazási szolgáltatások lényeges elemeinek meghatározását,
minőségét, a teljesítés módját, a részvételi díj összegét és annak tartalmát, a fizetési
feltételeket, illetve az egyéb, felszámításra kerülő költségeket az Utazásszervező által
közzétett tájékoztató (prospektus és weboldal) tartalmazza. Az utazási tájékoztatókban
foglaltak jelen szerződés elválaszthatatlan részét képezik. Az Utas kijelenti, hogy az
Utazásszervező által közzétett tájékoztatóban rögzített részletes feltételeket és az utazáshoz
szükséges és a vonatkozó jogszabályok által előírt fontos információkat megismerte, azokat
elfogadja, és az utazási szerződés aláírásával annak elfogadását igazolja. Az
Utazásszervező által nyújtott hiteles információk figyelmen kívül hagyásából eredő költségek
és károk az Utast terhelik.
</p>
<p>
5. Az úti okmányok (útlevél, esetlegesen vízum) beszerzése az Utas kötelessége és
felelőssége. Az Utas köteles az utazásra vonatkozó mindenkori jogszabályokat, előírásokat
(pl. útlevél-, ideiglenes útlevél, vám-, devizajogszabályok, be- és kiutazási szabályok,
egészségügyi előírások stb.) betartani; az ezek megszegéséből, be nem tartásából eredő
többletköltségek és károk az Utast terhelik.
</p>
<p>
6.Utazásszervező felelős a szerződésben foglalt valamennyi utazási szolgáltatás megfelelő
teljesítéséért, valamint, utazásszervező köteles segítséget nyújtani az utas számára, ha az
utazás során nehéz helyzetbe kerül.
</p>
      </p>

      <h2>SZERZŐDÉS MEGSZŰNÉSÉNEK ESETEI ÉS JOGI KÖVETKEZMÉNYEI</h2>
      <p>
      1. Az utazási iroda fenntartja magának a jogot, hogy
20 nappal az utazási csomag megkezdése előtt a 4 napnál hosszabb utak esetén,
7 nappal az utazási csomag megkezdése előtt a 2 és 4 nap közötti időtartamú utak esetén,
48 órával az utazási csomag megkezdése előtt, a 2 napnál rövidebb utak esetén, írásban tett
nyilatkozattal elálljon az utazási szerződéstől, ha a jelentkezők létszáma nem éri el a
meghirdetett legalacsonyabb résztvevőszámot.
A meghirdetett utak minimum létszáma 35 fő.
Az utazásszervező kártérítési kötelezettség nélkül jogosult felmondani az utazási szerződést,
ha az utazásszervezőt elháríthatatlan és rendkívüli körülmények gátolják a szerződés
teljesítésében, és indokolatlan késedelem nélkül, az utazási csomag megkezdése előtt
értesíti az utazót a szerződés felmondásáról. A fent rögzített esetekben az Utazásszervező
legkésőbb a szerződés felmondásától számított tizennégy napon belül visszafizeti az
Utasnak az általa vagy a nevében befizetett teljes díjat.
</p>
<p>
2. Amennyiben az utazást vis maior, háború, járvány, terrorizmusveszély, sztrájk, vagy
elháríthatatlan természeti jelenség, technikai akadályok befolyásolják, vagy meghiúsítják, a
szolgáltatások fenti okokból bekövetkezett elmaradásáért az Utazásszervező felelősséget
nem vállal, az ezen okból jelentkező többletköltségek az Utast terhelik. Az ilyen okból
bekövetkezett változásokért az Utazásszervező kártérítési felelősséggel nem tartozik.
</p>
<h2>LEMONDÁSI ÉS MÓDOSÍTÁSI FELTÉTELEK</h2>
<p>
1. Ha az Utas az utazás megkezdése előtt a szerződést felmondja – a Lemondási és
Módosítási Feltételek 3. pontban foglalt okból történő felmondás kivételével -
, avagy hatósági
elutasítás miatt (pl.: útlevél, vízum) nem vehet részt az utazáson, az alábbi mértékű
bánatpénzt köteles megfizetni. A felmondás napjának az számít, amikor az az
Utazásszervező irodájába beérkezett. A felmondás napja beleszámít, az utazás napja nem
számít bele a bánatpénz megállapításába
 60.-36. nap között, illetve szálláshely igénybevételére irányuló utazási szerződés
esetében (a részvételi díjnak) 20%-a.
 35.-20. nap között, illetve szálláshely igénybevételére irányuló utazási szerződés
esetében (a részvételi díjnak) 40%-a.
 19.-8. nap között közölt elállás esetén a szolgáltatás díjának (a részvételi díjnak)
80%-a.
 8 napon belüli lemondás, valamint meg nem jelenés esetén a részvételi díj 100%-a.
Egynapos program 15 napon belül történő lemondáskor a bánatpénz mértékére az alábbiak
érvényesek:
 15-7 napon belüli lemondás esetén a részvételi díj 10%-a
 6-4 napon belüli lemondás esetén a részvételi díj 50%-a
 3 napon belüli lemondás esetén, valamint meg nem jelenés esetén a részvételi díj
100%-a.
A fizetendő bánatpénzt az Utazásszervező jogosult levonni az Utasnak visszajáró részvételi
díj összegéből. Amennyiben az Utas által befizetett összeg nem fedezi az Utazásszervező
által igényelt bánatpénzt, úgy az Utas köteles azt (vagy a különbözetet) a felmondás
időpontjától (illetve a felmondás közlésének elmaradása esetén az utazás megkezdésének
időpontjától) számított 8 napon belül az Utazásszervezőnek megfizetni. A postai úton közölt
felmondás időpontját a felmondási nyilatkozatnak az Utazásszervezőhöz történő beérkezési
ideje határozza meg.
</p>
<p>
2. Ha az Utas az Utazásszervező által szervezett külföldi utazáson hatósági orvos (vagy
kórház) által igazolt betegségből eredő utazásképtelensége, továbbá igazolt katonai
szolgálata vagy elhalálozása miatt nem vehet részt, az Utazásszervezőt illető bánatpénzt a
biztosítótársaság a biztosítás feltételei szerint megtérítheti.
</p>
<p>
3. Utazásszervező fenntartja a jogát, hogy az utazási szerződés feltételeit egyoldalúan
módosítsa, amennyiben a változás nem jelentős – erről az Utast írásban értesíti. Ha az
Utazásszervező az utazási szerződés lényeges feltételét az indulás előtt rajta kívülálló okból
kívánja jelentősen módosítani, továbbá, ha az Utas által megrendelt szolgáltatáshoz
kapcsolódó, az utazásszervező által korábban elfogadott különleges igényeket nem tudja
teljesíteni, vagy a részvételi díj emelkedése a 8%-ot meghaladja, az Utazásszervező az
Utast haladéktalanul tájékoztatja a változtatásokról és az utazási csomag teljes díjának ezzel
összefüggő esetleges csökkenéséről. Az Utas a tájékoztatás alapján jogosult a változtatást
elfogadni vagy a szerződést bánatpénz megfizetése nélkül felmondani, amely döntését
haladéktalanul, de legkésőbb a tájékoztatás kézhezvételétől számított 3 naptári napon belül
köteles az Utazásszervezővel írásban közölni. Amennyiben ezen határidőn belül az Utas
nem ad választ, a szerződés a határidő lejártát követő napon megszűnik. Ha az utazási
szerződést a fentiek szerint az Utas felmondja és nem fogad el másik utazási csomagot, az
Utazásszervező haladéktalanul, de legkésőbb a szerződés felmondásától számított
tizennégy napon belül visszafizeti az Utasnak az általa vagy a nevében befizetett teljes díjat.
</p>
<p>
4. A fentiektől eltérően az utazási csomag megkezdését megelőzően az Utas bánatpénz
fizetése nélkül jogosult felmondani az utazási szerződést, ha a célállomás helyén vagy
annak közvetlen közelében, - amennyiben a célállomás, vagy annak közvetlen
környezetében a külpolitikáért felelős miniszter által vezetett minisztérium honlapján az
„utazásra nem javasolt” utazási célországokat és térségeket megjelölő felsorolásba felvételre
került - olyan elháríthatatlan és rendkívüli körülmények merülnek fel, amelyek az utazási
csomag teljesítését jelentős mértékben befolyásolják, vagy lényegesen befolyásolják az
utazók célállomásra való szállítását. Az utazási szerződés e bekezdés szerinti felmondása
esetén az Utas a teljes részvételi díj visszafizetésére jogosult, további kártérítést azonban
nem követelhet.
</p>
<p>
5. Az utazási szerződés lényeges elemeinek (úti cél, időpont, szálloda, utazók létszámának
csökkenése) módosítására az Utas részéről csak a IV/1. pontban meghatározott bánatpénz
megfizetése mellett és új foglalás keretei között van lehetőség.
V. BIZTOSÍTÁS
1. A biztosítások díjait a publikált csomagár nem tartalmazza.
2. Az Utazásszervező tájékoztatta az Utast arról, hogy a részvételi díj önmagában, külön
foglalás hiányában nem foglalja magában a baleset-, betegség-, poggyászbiztosítást,
amelyre tekintettel az Utazásszervező javasolja, hogy az utazók saját biztonságuk
érdekében érvényes és az utazásnak megfelelő feltételeket tartalmazó baleset-, betegség-
és poggyászbiztosítás birtokában keljenek útra. Az Utazásszervező a fenti eseményekre
kiterjedően arra biztosít lehetőséget, hogy az Utas biztosítást kössön az utazási szerződés
megkötésével egyidejűleg. A baleset-, betegség- és poggyászbiztosítás az Utazásszervező
által ajánlott biztosítási csomagként az utazási csomaghoz hozzáfoglalható.
</p>
<h2>EGYÉB RENDELKEZÉSEK</h2>
<p>
1. Az Utas tudomásul veszi, hogy az Utazásszervező számára szükséges megadni
foglalásonként legalább egy lakcímet a számlázáshoz, egy e-mail címet (ha rendelkezésre
áll) a kapcsolattartás miatt, illetve egy mobiltelefonszámot, amelyen az Utasok az utazás
előtt és alatt elérhetők, hogy az esetlegesen fellépő változásokról az Utazásszervező az
Utasokat értesíteni tudja. A telefonszám nem megadásából keletkező károkért az
Utazásszervező nem felelős. Az Utazásszervező vállalja ugyanakkor, hogy a megadott
telefonszámot kizárólag az utazással kapcsolatos információadásra használja, azt
bizalmasan kezeli az Adatkezelési Tájékoztatóban foglaltak szerint Az erre vonatkozó
részletes szabályozást az Utazásszervező Adatkezelési Tájékoztatója tartalmazza.
</p>
<p>
2. Az Utazásszervező nem köteles a részvételi díjat visszatéríteni, ha az Utas valamelyik
kifizetett szolgáltatást saját elhatározásából vagy érdekkörében felmerült okból nem vette
igénybe.
</p>
<p>
3. Az utazás első és utolsó napja az utazási cél megközelítéséhez szükséges utazással telik
el, ezek a napok beszámítanak az utazási ajánlatban megjelölt és a teljes utazásra
vonatkoztatott napok számába.
</p>
<p>
4. Ha az utazás ideje alatt az utas általa már kifizetett szolgáltatásokról lemond, vagy
bizonyos szolgáltatásokat nem vesz igénybe, nem kérhet ezekért kártérítést, sem ezek
ellenértékére, sem részvételi díjcsökkentésre nem tarthat igényt.
</p>
<p>
5. Az Utas az utazás során az általa más személynek okozott kárért közvetlen felelősséggel
tartozik. Az Utas a célterületen okozott kárért (transzfer út, szállodai tartózkodás, stb.)
közvetlen felelősséggel tartozik.
</p>
<p>
6. Az Utazásszervező a szolgáltatás természeti környezetének rendkívüli okból történő
megváltozásáért, az időjárás megváltozásából, illetve természeti okokból eredő
kellemetlenségekért vagy károkért felelősséget nem vállal.
</p>
<p>
7. Az Utas kártérítésre jogosult az Utazásszervezőtől minden olyan kárért, amely az Utast a
szolgáltatások nem szerződésszerű teljesítése miatt éri, amennyiben bizonyítani tudja
kártérítési jogalapját és összegszerűségét, amelyet indokolatlan késedelem nélkül meg kell
fizetni. Az Utas nem jogosult kártérítésre, ha az Utazásszervező bizonyítja, hogy a
szerződésszegés a.) az utazónak róható fel, b.) olyan harmadik személy magatartására
vezethető vissza, aki az utazási csomagra vonatkozó szerződésben foglalt utazási
szolgáltatás teljesítésével nincsen kapcsolatban, és a szerződésszegést az utazásszervező
észszerű elvárhatóság mellett sem láthatta előre, vagy az elháríthatatlan volt, vagy c.)
elháríthatatlan és rendkívüli körülmények miatt következett be. Amennyiben nemzetközi
egyezmények nem korlátozzák a szolgáltatás nyújtója által fizetendő kártérítés mértékét, a
kártérítés mértékére a Ptk. szerződésszegéssel okozott kár mértékére vonatkozó szabályai
alkalmazandók, azzal, hogy az Utazásszervező a teljes részvételi díj összegének
háromszorosát meghaladó része tekintetében kizárja kártérítési felelősségét, amely kizárás
nem terjed ki a személyi sérülésre, illetve a szándékosan vagy súlyos gondatlanságból
okozott kárra.
</p>
<p>
8. Ha a szerződésszegés az utazási szerződés lényeges tartalmát érinti, és az
Utazásszervező az Utas által megszabott észszerű határidőn belül azt nem orvosolja, az
Utas bánatpénz megfizetése nélkül jogosult az utazási szerződést felmondani, valamint
díjengedményt, illetve kártérítést követelhet. Az Utas e bekezdésben foglalt nyilatkozatait
írásban, igazolható módon köteles megtenni, elsősorban Utazásszervező képviselőjének.
</p>
<p>
9. Az utazási szerződés nem megfelelő teljesítése esetén a panaszra okot adó esemény
helyszínén az Utas köteles kárenyhítő magatartást tanúsítani és ennek érdekében
megfelelően eljárni. Így az Utasnak az Utazásszervező képviselőjével haladéktalanul
közölnie kell a kifogásokat, az esetlegesen észlelt szerződésszegést. Az Utazásszervező
képviselője köteles az Utas bejelentését, illetve annak a helyszíni szolgáltatóval való
közlésének a tényét az Utas kérésére jegyzőkönyvbe foglalni, és ennek egyik példányát az
Utasnak átadni. A panaszt az utazás tényleges befejezését követően 8 napon belül a
jegyzőkönyvvel együtt írásban, postai úton vagy személyesen kell tudomásra hozni az
Utazásszervezőnél. A jegyzőkönyv rögzítésének elmulasztásából, valamint a közlések
késedelméből eredő károkért az Utazásszervező nem vállal felelősséget, ezek az Utast
terhelik. Az Utazásszervező köteles a bejelentést részletesen kivizsgálni és álláspontjáról a
kárigény bejelentésétől számított 30 napon belül írásban tájékoztatni az Utast. A szerződő
felek kifejezetten rögzítik, hogy az Utas részéről felmerülő panasz esetén a vitás kérdéseket
elsődlegesen békés úton, tárgyalások, illetve levelezések formájában kísérlik meg rendezni.
Mindaddig, ameddig az egyeztetés eredményre vezethet, egyik fél sem fordulhat sem a
nyomtatott, sem az elektronikus médiához. Ezen kötelezettség megsértésével okozott kárért
az Utas kártérítési felelősséggel tartozik az Utazásszervező felé.
</p>
<p>
10. Előre nem látható akadályok (a szálloda túltöltése vagy műszaki okok) esetén az
Utazásszervező jogosult, hogy kártérítési felelősség nélkül a lefoglalt szálláshellyel
megegyező vagy magasabb kategóriájú másik szállást biztosítson többletköltség
felszámítása nélkül. Alacsonyabb kategóriájú szálloda esetén – amennyiben az Utas által az
elfogadásra kerül – az utazásszervező a változásból adódó árkülönbözetet az Utas részére
visszatéríti (díjengedmény). Felek rögzítik, hogy a jelen pontban írtak alapján felkínált
helyettesítő szolgáltatás Utas által történő elfogadásának minősül, amennyiben az Utas a
helyettesítő szolgáltatást bármely módon – ideértve a ráutaló magatartást is – elfogadja. Az
Utas kizárólag akkor utasíthatja el a felajánlott helyettesítő szolgáltatást, ha az lényegesen
különbözik az utazási szerződésben foglaltaktól, illetve, ha az Utazásszervező által ajánlott
díjengedmény nem megfelelő. Ebben az esetben, illetve amennyiben helyettesítő
szolgáltatás nyújtása nem lehetséges, az Utas díjengedményre és kártérítésre jogosult.
</p>
<p>
11. A poggyász őrzéséről és felügyeletéről az utazás során az Utas köteles gondoskodni. A
repülőn, buszon, valamint a szállodában elveszett csomagokért az Utazásszervező
felelősséget nem vállal. Ilyen esetben azonnal a helyszínen az érintett társasághoz kell
fordulni a problémával. A szállodában kihelyezett széfekért, és az abban elhelyezett
tárgyakért kizárólag az adott szálloda vállal felelősséget, az Utazásszervező ezen
szolgáltatásokra nincs befolyással.
</p>
<p>
12. Gyermekvédelmi rendelkezések
Az utazásszervező nyilatkozik arról, hogy az általa nyújtott utazási szolgáltatás vagy az
utazási csomag közvetítése nem irányul a gyermekek jogainak csorbítására, így különösen a
tizennyolcadik életévét be nem töltött személy sérelmére elkövetett nemi élet szabadsága és
a nemi erkölcs elleni bűncselekmények elkövetésére.
</p>
<p>
13. A szerződő felek kötelezettséget vállalnak arra, hogy igényeiket, vitás kérdéseiket
elsősorban békés úton, megegyezéssel rendezik. A fogyasztóvédelemről szóló 1997. évi
CLV törvény szerint az utas, mint fogyasztó lakhelye/tartózkodási helye/székhelye szerinti
illetékes békéltető testületnél eljárást kezdeményezhet, ha panaszügyének rendezését az
utazási iroda megkísérelte, de az nem vezetett eredményre. A fogyasztóvédelmi szabályok
megsértése esetén a fogyasztók elsősorban a területileg illetékes járási hivatalokhoz
fordulhatnak
</p>
<p>
14. Az Utazásszervező kijelenti, hogy a katalógusban, leírásban esetlegesen megjelent
tartalmi és nyomdai hibákért felelősséget nem vállal.
A jelentkezést elfogadó nyilatkozatot átvettem, a fenti utazási szerződést az Általános
Előzetes Tájékoztatót, az Adatvédelmi Tájékoztatót megismertem, azokat elfogadom, és a
velem együtt utazókra nézve is kötelező érvényűnek tekintem.
</p>
      <p><strong>Utolsó frissítés:</strong> 2025. május 5.</p>
    </div>
  );
};

export default TermsOfService;
